/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

// Checks if all current permissions are selected
export const isAllPermissionsSelected = (
    currentPermissions = [],
    selectedPermissions = [],
) => {
    return (
        currentPermissions.length > 0 &&
        currentPermissions.every((permission) =>
            selectedPermissions.some((item) => item.id === permission.id),
        )
    );
};

// Selects or deselects all current permissions
export const handleSelectAllPermissions = (
    checked,
    currentPermissions = [],
    setSelectedPermissions,
) => {
    if (checked) {
        setSelectedPermissions((prev = []) => {
            const existingIds = new Set(prev.map((item) => item.id));

            const permissionsToAdd = currentPermissions
                .filter((permission) => !existingIds.has(permission.id))
                .map((permission) => ({ id: permission.id }));

            return [...prev, ...permissionsToAdd];
        });
    } else {
        const currentIds = currentPermissions.map((permission) => permission.id);

        setSelectedPermissions((prev = []) =>
            prev.filter((item) => !currentIds.includes(item.id)),
        );
    }
};